import logo from './logo.svg';
import './App.css';
//importing components
import Results from './Components/Results';

function App() {
  return (
    <div>
      <Results />
    </div>
  );
}

export default App;
